import { set, get, Store } from 'idb-keyval';

import Storage, { MODE } from './Storage';
import { TTLS } from './constants';
import MemoryStorage from './MemoryStorage';

export const DB_NAME = 'PeYa_Web';

class IndexedDBKeyValueStore {
  constructor(storeName) {
    this.store = new Store(DB_NAME, storeName);
    this.memory = new MemoryStorage();
  }

  async get(key) {
    const memoryValue = this.memory.get(key);
    if (memoryValue) return memoryValue;

    const record = await get(key, this.store);
    this.memory.set(key, record);

    return record;
  }

  async set(key, value) {
    await set(key, value, this.store);
    this.memory.set(key, value);
  }
}

class FallbackStorage {
  constructor(name) {
    this.store = new Storage({ ttl: TTLS.WITHOUT, mode: MODE.STORAGE });
    this.name = name;
  }

  get(key) {
    return this.store.get(`${this.name}_${key}`);
  }

  set(key, value) {
    return this.store.set(`${this.name}_${key}`, value);
  }
}

function isWindowDefined() {
  return (
    typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement
  );
}

class IndexedDBStorage {
  constructor({ name }) {
    this.name = name;
    if (isWindowDefined() && 'indexedDB' in window) {
      this.storage = new IndexedDBKeyValueStore(this.name);
      this.indexedDB = true;
    } else {
      this.storage = new FallbackStorage(this.name);
      this.indexedDB = false;
    }
  }

  async set(key, value) {
    try {
      await this.storage.set(key, value);
      return true;
    } catch (error) {
      return false;
    }
  }

  async get(key) {
    try {
      const data = await this.storage.get(key);
      return data;
    } catch (error) {
      return undefined;
    }
  }
}

export default IndexedDBStorage;
